import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import { updateOpenGraphTags } from '../utils/opengraph';

const AboutUs = ({ navigateToHome, navigateToBlog, navigateToB2B, backendUrl, publicSettings, navigateToPrivacy, navigateToTerms, navigateToAbout, navigateToSitemap }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // SEO setup for About page
  useEffect(() => {
    // Update page title
    document.title = "Rólunk – FogPortál.hu | Fogászat kereső és fogorvos kereső portál";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.getElementsByTagName('head')[0].appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'A FogPortál.hu célja, hogy mindenki könnyedén megtalálja a számára megfelelő fogorvost és rendelőt. Országos lefedettség, naprakész adatok, átláthatóság.');
    
    // Add keywords meta tag
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.getElementsByTagName('head')[0].appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'fogászat, fogorvos kereső, fogászat kereső, fogorvos Magyarországon, budapesti fogászat, magánrendelő, fogászati portál, fogorvos keresés');
    
    // Update OpenGraph meta tags for About page
    updateOpenGraphTags({
      title: 'Rólunk – FogPortál.hu | Fogászat kereső és fogorvos kereső portál',
      description: 'A FogPortál.hu célja, hogy mindenki könnyedén megtalálja a számára megfelelő fogorvost és rendelőt. Országos lefedettség, naprakész adatok, átláthatóság.',
      type: 'website',
      url: `${window.location.origin}/rolunk`,
      imageAlt: 'FogPortál.hu - Rólunk oldal'
    }, publicSettings.default_og_image);
    
    // Cleanup function to reset meta tags when component unmounts
    return () => {
      document.title = "FogPortál.hu - Magyarország prémium fogászati portálja";
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Találja meg a legjobb fogorvost Magyarországon! Több mint 1000 fogászati klinika egy helyen.');
      }
    };
  }, [publicSettings.default_og_image]);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Rólunk – FogPortál.hu | Fogászat kereső és fogorvos kereső portál"
        description="Ismerje meg a FogPortál.hu csapatát és küldetésünket. Magyarország legnagyobb fogászat kereső és fogorvos kereső portálja."
        keywords="FogPortál, rólunk, fogászat kereső portál, fogorvos kereső"
        canonicalUrl={`${window.location.origin}/rolunk`}
      />
      {/* Header */}
      <header className="bg-white shadow-lg border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex items-center">
              <button 
                onClick={navigateToHome}
                className="flex items-center space-x-3"
              >
                <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-green-600 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 2.21 1.79 4 4 4s4-1.79 4-4v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 15c0 1.1-.9 2-2 2s-2-.9-2-2v-1h4v1zm1.46-4.86C14.8 12.64 14 13.26 14 14v1h-4v-1c0-.74-.8-1.36-1.46-.86C7.06 12.5 6 10.84 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.84-1.06 3.5-2.54 4.14z"/>
                  </svg>
                </div>
                <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                  FogPortál.hu
                </h1>
              </button>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center space-x-1">
              <button 
                onClick={navigateToHome}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Főoldal
              </button>
              <button 
                onClick={navigateToB2B}
                className="px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium text-sm transition-all duration-200"
              >
                Megjelenés fogászatoknak
              </button>
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-gray-50"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        
        {/* Mobile menu dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-2 pt-4 px-4">
              <button 
                onClick={() => {
                  navigateToHome();
                  setIsMobileMenuOpen(false);
                }}
                className="px-4 py-3 text-left text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium transition-all duration-200"
              >
                Főoldal
              </button>
              <button 
                onClick={() => {
                  navigateToB2B();
                  setIsMobileMenuOpen(false);
                }}
                className="px-4 py-3 text-left text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg font-medium transition-all duration-200"
              >
                Megjelenés fogászatoknak
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-50 to-turquoise-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Rólunk – <span className="text-blue-600">FogPortál.hu</span>
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-600 mb-8 max-w-4xl mx-auto">
              Országos <strong>fogászat kereső</strong> és <strong>fogorvos kereső</strong> portál
            </h2>
            <div className="flex justify-center">
              <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 2.21 1.79 4 4 4s4-1.79 4-4v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 15c0 1.1-.9 2-2 2s-2-.9-2-2v-1h4v1zm1.46-4.86C14.8 12.64 14 13.26 14 14v1h-4v-1c0-.74-.8-1.36-1.46-.86C7.06 12.5 6 10.84 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 1.84-1.06 3.5-2.54 4.14z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Introduction */}
        <div className="mb-16">
          <p className="text-xl text-gray-700 leading-relaxed max-w-5xl mx-auto text-center">
            A <strong>FogPortál.hu</strong> Magyarország egyik legnagyobb és legátfogóbb <strong>fogászat kereső</strong> és <strong>fogorvos kereső</strong> portálja, 
            amelynek célja, hogy a páciensek könnyedén megtalálják a számukra legmegfelelőbb fogorvost és rendelőt. 
            Legyen szó <strong>budapesti fogászatról</strong>, vidéki <strong>magánrendelőről</strong> vagy speciális szakterületről, 
            nálunk mindenki egyszerűen, gyorsan és megbízható információk alapján kereshet.
          </p>
        </div>

        {/* Mission Section */}
        <section className="mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Küldetésünk</h2>
              <p className="text-lg text-gray-700 mb-6">
                A <strong>FogPortál.hu</strong> küldetése, hogy átlátható, naprakész és megbízható információt biztosítson 
                mindenki számára, aki <strong>fogorvost keres Magyarországon</strong>. Tudjuk, hogy a megfelelő szakember és rendelő 
                kiválasztása nem könnyű feladat, ezért létrehoztunk egy olyan online rendszert, ahol:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">✓</span>
                  összehasonlíthatóak a <strong>fogászatok és fogorvosok</strong>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">✓</span>
                  elérhetőek a legfontosabb adatok (cím, nyitvatartás, szolgáltatások)
                </li>
                <li className="flex items-start">
                  <span className="text-blue-600 mr-3">✓</span>
                  kiemelt figyelmet kap a minőség és a bizalom
                </li>
              </ul>
            </div>
            <div className="flex justify-center">
              <div className="bg-blue-50 rounded-2xl p-8">
                <svg className="w-48 h-32 text-blue-200" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="bg-turquoise-50 rounded-2xl p-8">
                <svg className="w-48 h-32 text-turquoise-200" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Hogyan működik a fogászat kereső?</h2>
              <p className="text-lg text-gray-700 mb-6">
                A <strong>FogPortál.hu</strong> egy felhasználóbarát kereső rendszer, ahol több szűrési lehetőség áll rendelkezésre:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <span className="text-turquoise-600 mr-3">🏙️</span>
                  <strong>Város és kerület szerint</strong> – gyorsan megtalálhatóak a <strong>budapesti fogászatok</strong> vagy vidéki rendelők
                </li>
                <li className="flex items-start">
                  <span className="text-turquoise-600 mr-3">⚕️</span>
                  <strong>Szolgáltatások alapján</strong> – például esztétikai fogászat, szájsebészet, implantológia, gyermekfogászat
                </li>
                <li className="flex items-start">
                  <span className="text-turquoise-600 mr-3">⏰</span>
                  <strong>Nyitvatartás szerint</strong> – hétvégi vagy esti rendelést is kereshetnek a páciensek
                </li>
              </ul>
              <p className="text-lg text-gray-700 mt-6">
                A célunk, hogy bárki gyorsan és egyszerűen találjon olyan <strong>fogorvost</strong>, akiben megbízik, 
                és aki a legjobb megoldást kínálja a problémájára.
              </p>
            </div>
          </div>
        </section>

        {/* Why Choose Us - Highlighted Box */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-blue-50 to-turquoise-50 rounded-2xl p-8 md:p-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Miért válassza a FogPortál.hu-t?
            </h2>
            <p className="text-lg text-gray-700 mb-8 text-center max-w-4xl mx-auto">
              A <strong>FogPortál.hu</strong> nem csupán egy egyszerű listaoldal – hanem egy átfogó <strong>fogászat kereső</strong> platform, 
              amely számos előnyt kínál:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">🗺️</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Országos lefedettség</h3>
                <p className="text-gray-600 text-sm">több száz <strong>fogorvos</strong> és rendelő elérhető</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-turquoise-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">🔍</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">SEO-optimalizált megjelenés</h3>
                <p className="text-gray-600 text-sm">a csatlakozó <strong>fogászatok</strong> könnyebben megtalálhatók a Google-ben</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">📱</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Naprakész adatok</h3>
                <p className="text-gray-600 text-sm">folyamatosan frissített címek, elérhetőségek és szolgáltatások</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">⭐</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Kiemelt megjelenési lehetőségek</h3>
                <p className="text-gray-600 text-sm">több látogató, nagyobb online jelenlét</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">📝</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Blog és szakmai tartalmak</h3>
                <p className="text-gray-600 text-sm">hasznos információk pácienseknek és fogorvosoknak egyaránt</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <span className="text-2xl">🤝</span>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Megbízható közösség</h3>
                <p className="text-gray-600 text-sm">ellenőrzött <strong>magánrendelők</strong> és szakemberek</p>
              </div>
            </div>
          </div>
        </section>

        {/* Community Section */}
        <section className="mb-16">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Közösség és szakértelem</h2>
            <p className="text-lg text-gray-700 mb-8 max-w-4xl mx-auto">
              A <strong>FogPortál.hu</strong> nemcsak egy <strong>fogászat kereső</strong> oldal, hanem egy közösség is, 
              amely összehozza a pácienseket és a fogorvosokat. Fontos számunkra a szakmai hitelesség, 
              ezért minden partnerünk ellenőrzött adatokkal jelenik meg.
            </p>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto">
              Célunk, hogy a portál segítségével mindenki megtalálja a számára legjobb szakembert – 
              legyen szó egyszerű fogtömésről, implantátumról vagy teljes körű esztétikai mosolytervezésről.
            </p>
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center bg-gradient-to-r from-blue-600 to-turquoise-600 rounded-2xl p-8 md:p-12 text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Böngésszen a több száz rendelő között!
          </h2>
          <p className="text-lg mb-8 opacity-90">
            Találja meg az Ön számára ideális fogorvost a <strong>FogPortál.hu fogászat keresőjével</strong>!
          </p>
          <button 
            onClick={navigateToHome}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors shadow-lg"
          >
            Keresés indítása →
          </button>
        </section>

      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo and Description */}
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold text-blue-400 mb-4">FogPortál.hu</h3>
              <p className="text-gray-300 mb-6 max-w-md">
                Magyarország prémium fogászati portálja. Professzionális megoldások 
                fogorvosoknak és pácienseknek egyaránt.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Gyors linkek</h4>
              <ul className="space-y-2">
                <li><button onClick={navigateToHome} className="text-gray-300 hover:text-blue-400 transition-colors">Főoldal</button></li>
                <li><button onClick={navigateToB2B} className="text-gray-300 hover:text-blue-400 transition-colors">Fogorvosoknak</button></li>
                <li><button onClick={navigateToSitemap} className="text-gray-300 hover:text-blue-400 transition-colors">Oldaltérkép</button></li>
              </ul>
            </div>

            {/* Legal and Support */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Információk</h4>
              <ul className="space-y-2">
                <li><button onClick={navigateToPrivacy} className="text-gray-300 hover:text-blue-400 transition-colors">Adatkezelési tájékoztató</button></li>
                <li><button onClick={navigateToTerms} className="text-gray-300 hover:text-blue-400 transition-colors">ÁSZF</button></li>
                <li><a href="/megjelenes-fogaszatoknak" className="text-gray-300 hover:text-blue-400 transition-colors">Kapcsolat</a></li>
                <li><button onClick={navigateToAbout} className="text-gray-300 hover:text-blue-400 transition-colors">Rólunk</button></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © 2025 FogPortál.hu. Minden jog fenntartva.
              </p>
              <p className="text-gray-400 text-sm mt-4 md:mt-0">
                Készítette: <span className="text-blue-400">FogPortál Csapat</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};


export default AboutUs;
